<template>
  <div
    v-show="openRightPanel"
    ref="btn"
    class="save-phone"
  >
    <co-button
      left-icon="#qrcode"
      @click="showQr"
    >
      {{ $t('保存到手机') }}
    </co-button>
    <div
      v-show="isShow"
      class="code-wrapper"
      :style="{top:codeTop,left:codeLeft}"
    >
      <img
        :src="getCreateCode()"
        alt="QR code"
      ><!--
        --><div>{{ $t('扫描二维码在手机上查看') }}</div>
    </div>
  </div>
</template>
<script>
import coButton from 'components/common/button/index.vue'

export default {
  components: {
    coButton,
  },
  props: {
    codeTop: {
      type: String,
      default: '49px',
      isShowPhone: Object,
    },
  },
  data() {
    return {
      isShow: false, // 二维码框展示
      codeLeft: '', // 二维码框left值  用于居中显示
      isShowPhone: this.isShowPhone // 是否显示保存到手机
    }
  },
  computed: {
    openRightPanel() {
      const param = this.$route.params || {}
      const { neid } = param
      if (neid.length > 32) {
        return false
      }else {
        return true
      }
    },
  },
  watch: {
    /**
             * 监听二维码框是否展示
             */
    isShow(n) {
      const iframe = document.getElementById('pdfframe')
      if (n) {
        document.addEventListener('click', this.otherClick)
        // 可传一个函数来注册iframe的点击事件
        // 目前预览页面会有一个iframe所以加到组件里
        iframe && iframe.contentDocument && iframe.contentDocument.addEventListener('click', this.otherClick)
        return
      }
      document.removeEventListener('click', this.otherClick)
      iframe && iframe.contentDocument && iframe.contentDocument.removeEventListener('click', this.otherClick)
    },
  },
  methods: {
    /**
             * 生成的二维码
             */
    getCreateCode() {
      // 重构外链的url为/v/link/view, 旧外链的url为/link/view,由于未重构H5外链，所以访问H5外链需要修改url成/link/view
      const fullPath = window.location.origin + this.$route.fullPath
      return `/v2/image/qrcode?t=${fullPath}&d=141`
    },
    /**
             * 点击空白区域关闭
             */
    otherClick(e) {
      const qr = this.$refs.btn
      if (qr.contains(e.target)) {
        return
      }
      this.isShow = false
    },
    /**
             * 点击按钮展示二维码
             */
    showQr() {
      this.codeLeft = `${-(192 - (this.$refs.btn.offsetWidth - 12)) / 2}px`
      this.isShow = !this.isShow
    },
  },
}
</script>
<style lang="less" scoped>
@import '~less/button.less';
.save-phone{
  position: relative;
  display: inline-block;
}
//保存到手机
.qrcode-img{
  width: 16px;
  height: 16px;
  vertical-align: -2.5px;
  margin-right: 8px;
}

//二维码框
.code-wrapper{
  width: 192px;
  // min-height: 235px;
  box-sizing: border-box;
  background: #fff;
  position: absolute;
  // top: 45px;
  left: -50px;
  text-align: center;
  box-shadow: 0 2px 12px 0 rgba(27,39,51,0.15);
  border-radius: 2px;
  font-size: 0;
  z-index: 10;
  img{
    margin: 20px auto auto;
    display: block;
    width: 150px;
    height: 150px;
  }
  div{
    margin: 8px auto 14px;
    width: 139px;
    //min-height: 40px;
    box-sizing: border-box;
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #1B2733;
    line-height: 20px;
  }
}
//框-小三角
.code-wrapper::after{
  display: block;
  content: "";
  width: 0;
  height: 0;
  border-bottom: 5px solid #fff;
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
  position: absolute;
  left: 89px;
  top: -5px;
}
.pointer{
  cursor: pointer;
}
</style>
